import axios from '@/utils/axios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        stockAdjustment: null,
        stockAdjustments: [],
        userRules: null
    },
    mutations: {
        setStockAdjustment(state, payload) {
            state.stockAdjustment = payload;
        },
        setStockAdjustments(state, payload) {
            state.stockAdjustments = payload;
        },
        setUserRules(state, payload) {
            state.userRules = payload;
        }
    },
    actions: {
        storeStockAdjustment({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/stock-adjustments`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        updateStockAdjustment({rootState, dispatch}, payload) {
            return new Promise((resolve, reject)=> {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/stock-adjustments/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeStockAdjustment({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/stock-adjustments/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeStockAdjustments({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/stock-adjustments`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchStockAdjustment({commit, rootState, dispatch}, payload) {
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/stock-adjustments/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setStockAdjustment', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchStockAdjustments({commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/stock-adjustments?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setStockAdjustments', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchUserRules({commit, rootState,state}) {
            if(!state.userRules) {
                return new Promise((resolve, reject) => { 
                    axios.request({
                        method: 'get',
                        url: `${rootState.warehouse.routePrefix}/stock-adjustments-rules`,
                        headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                    })
                    .then((response) => {
                        commit('setUserRules', response.data);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        // if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                        reject(error);
                    })
                })
            }
        }

    }
}